<template>
    <div class='up-down' :class="{ deleted: isDeleted, 'is-up': !down, 'is-down': down }" :style="{ minWidth: minWidth, padding: down ? '7px 12px' : '10px 12px' }">
        <div class="up-down-left fx-v-center" :style="{ borderRight: showEdit ? '1px solid #ddd' : 'none' }">
            <slot name="down" v-if="down && showUpDown"/>
            <slot name="up" v-if="!down && showUpDown"/>
            <slot v-if="showUpDown"/>
        </div>
        <div class="up-down-right fx-v-center" v-if="showEdit">
            <button class="edit-btn" @click="$emit('edit')">编辑</button>
        </div>
        <i v-if="showUpDown" class="iconfont" :class="down ? 'iconarrow_down' : 'iconarrow_up'" @click="() => { $emit('change', down); down = !down }"/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            down: true
        }
    },
    props: {
        showUpDown: {
            type: Boolean,
            default: true
        },
        showEdit: {
            type: Boolean,
            default: false
        },
        minWidth: {
            type: String,
            default: '1000px'
        },
        isDeleted: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.iconfont {
    font-size: 14px;
    font-weight: bolder;
    color: #3C90FF;
    cursor: pointer;
}

.iconarrow_down::before {
    content: '展开 \e60b';
}

.iconarrow_up::before {
    content: '收起 \e60c';
}

.up-down {
    position: relative;
    display: flex;
    align-items: center;
    padding: 7px 12px;
    min-height: 50px;
    background: #F9F9F9;
    border-top: 1px solid #ebebeb;
    overflow: hidden;

    &.is-up.deleted::before {
        left: -20px;
        top: 3px;
        transform: rotate(-45deg) scale(.8);
    }

    &.is-down.deleted::before {
        left: -24px;
        top: -2px;
        transform: rotate(-45deg) scale(.5);
    }

    &.deleted::before {
        content: '已删除';
        position: absolute;
        left: 0;
        top: 0;
        padding: 4px 14px;
        font-size: 12px;
        background: #e51c23;
        color: #fff;
        z-index: 2;
    }

    &-left {
        flex: 1;
        border-right: 1px solid #ddd;
    }

    &-right {
        flex: 0 0 330px;
        box-sizing: border-box;

        .edit-btn {
            padding: 0;
            margin-left: 20px;
            color: #009688;
            border: 1px solid #dddddd;
            background-color: #f9f9f9;
            box-sizing: border-box;
            width: 100px;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
            font-weight: bolder;
            border-radius: 4px;
            outline: none;
            ;
            &:active {
                transform: scale(0.9);
            }
        }
    }

    &-left {
        flex: 1;
        border-right: 1px solid #ddd;
    }

    &-right {
        flex: 0 0 330px;
        box-sizing: border-box;

        .edit-btn {
            padding: 0;
            margin-left: 20px;
            color: #009688;
            border: 1px solid #dddddd;
            background-color: #f9f9f9;
            box-sizing: border-box;
            width: 100px;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
            font-weight: bolder;
            border-radius: 4px;
            outline: none;
            ;
            &:active {
                transform: scale(0.9);
            }
        }
    }

    .iconfont {
        position: absolute;
        top: 18px;
        right: 12px;
    }
}
</style>
